import { useHasClover } from 'payments/hooks/usePayments';
import { useCloverPaymentForm } from 'payments/providers/CloverPaymentFormProvider';
import type {
  PartialSaveOptions,
  SaveCardOnFileMutation
} from 'payments/types/form';

/**
 * usePaymentForm exposes the appropriate handler for saving the card on file
 */
export const usePaymentForm = () => {
  const cloverPaymentForm = useCloverPaymentForm();

  const saveCardOnFileError = () => {
    const error = `usePaymentForm must be used within CloverPaymentFormProvider context`;
    throw new Error(error);
  };

  const hasClover = useHasClover();

  if (!hasClover) {
    return null;
  }

  return {
    retrieveToken: cloverPaymentForm
      ? cloverPaymentForm!.retrieveToken
      : saveCardOnFileError,
    saveCardOnFile: cloverPaymentForm
      ? cloverPaymentForm!.saveCardOnFile
      : saveCardOnFileError,
    applySavedPaymentMethod: applySavedPaymentMethod()
  };
};

// TODO: This is redundant with handleSaveCardOnFileMutation and should be
// removed in the future
export const applySavedPaymentMethod =
  () =>
  async (saveOptions: PartialSaveOptions, mutate: SaveCardOnFileMutation) => {
    const { firstName, lastName, phoneCode, phone, ...otherOptions } =
      saveOptions;

    const options = {
      ...otherOptions,
      name: `${firstName} ${lastName}`,
      phone: `+${phoneCode}${phone}`
    };

    // NOTE: This callback will call the mutation to save the card on file
    mutate(options);
  };
